var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "84px",
    height: "84px",
    viewBox: "0 0 84 84",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "F1-\\u51FA\\u9519\\u72B6\\u6001",
    transform: "translate(-165.000000, -356.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-2",
    transform: "translate(165.000000, 356.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    stroke: "#B2B2B2",
    strokeWidth: 4,
    cx: 42,
    cy: 42,
    r: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-26",
    transform: "translate(38.000000, 21.000000)",
    fill: "#B2B2B2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,0 C6.10791899,-3.87218436e-16 7.81672496,1.70880597 7.81672496,3.81672496 C7.81672496,3.87637605 7.81532654,3.93601895 7.81253085,3.9956045 L6.61390976,29.5422929 C6.54936827,30.9178912 5.41529778,32 4.03818622,32 C2.66016796,32 1.52447233,30.9189208 1.45661091,29.5425745 L0.196982643,3.99514679 C0.0934239457,1.8947983 1.7121419,0.108178517 3.81249039,0.00461981991 C3.87494618,0.00154040721 3.93746834,1.14868788e-17 4,0 Z",
    id: "\\u77E9\\u5F62"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    cx: 4,
    cy: 39,
    r: 3
  }))))))));
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iODRweCIgaGVpZ2h0PSI4NHB4IiB2aWV3Qm94PSIwIDAgODQgODQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDYxICg4OTU4MSkgLSBodHRwczovL3NrZXRjaC5jb20gLS0+CiAgICA8dGl0bGU+57yW57uEIDI8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZyBpZD0i6aG16Z2iLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJGMS3lh7rplJnnirbmgIEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xNjUuMDAwMDAwLCAtMzU2LjAwMDAwMCkiPgogICAgICAgICAgICA8ZyBpZD0i57yW57uELTIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE2NS4wMDAwMDAsIDM1Ni4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxjaXJjbGUgaWQ9IuakreWchuW9oiIgc3Ryb2tlPSIjQjJCMkIyIiBzdHJva2Utd2lkdGg9IjQiIGN4PSI0MiIgY3k9IjQyIiByPSI0MCI+PC9jaXJjbGU+CiAgICAgICAgICAgICAgICA8ZyBpZD0i57yW57uELTI2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzOC4wMDAwMDAsIDIxLjAwMDAwMCkiIGZpbGw9IiNCMkIyQjIiPgogICAgICAgICAgICAgICAgICAgIDxnIGlkPSLnvJbnu4QtMjciPgogICAgICAgICAgICAgICAgICAgICAgICA8cGF0aCBkPSJNNCwwIEM2LjEwNzkxODk5LC0zLjg3MjE4NDM2ZS0xNiA3LjgxNjcyNDk2LDEuNzA4ODA1OTcgNy44MTY3MjQ5NiwzLjgxNjcyNDk2IEM3LjgxNjcyNDk2LDMuODc2Mzc2MDUgNy44MTUzMjY1NCwzLjkzNjAxODk1IDcuODEyNTMwODUsMy45OTU2MDQ1IEw2LjYxMzkwOTc2LDI5LjU0MjI5MjkgQzYuNTQ5MzY4MjcsMzAuOTE3ODkxMiA1LjQxNTI5Nzc4LDMyIDQuMDM4MTg2MjIsMzIgQzIuNjYwMTY3OTYsMzIgMS41MjQ0NzIzMywzMC45MTg5MjA4IDEuNDU2NjEwOTEsMjkuNTQyNTc0NSBMMC4xOTY5ODI2NDMsMy45OTUxNDY3OSBDMC4wOTM0MjM5NDU3LDEuODk0Nzk4MyAxLjcxMjE0MTksMC4xMDgxNzg1MTcgMy44MTI0OTAzOSwwLjAwNDYxOTgxOTkxIEMzLjg3NDk0NjE4LDAuMDAxNTQwNDA3MjEgMy45Mzc0NjgzNCwxLjE0ODY4Nzg4ZS0xNyA0LDAgWiIgaWQ9IuefqeW9oiI+PC9wYXRoPgogICAgICAgICAgICAgICAgICAgICAgICA8Y2lyY2xlIGlkPSLmpK3lnIblvaIiIGN4PSI0IiBjeT0iMzkiIHI9IjMiPjwvY2lyY2xlPgogICAgICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+";
export { SvgWarning as ReactComponent };